import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { Tooltip } from '@telialt/common-tooltip/src';

export const LeadInfoForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('200')};

    ${purpurMedia('lg')`
        margin-bottom: ${getPurpurSpacing('300')};
    `};
`;

export const HelpRow = styled.div`
    display: flex;
    align-items: center;
`;

export const HelpText = styled.div`
    flex: 1;
    font-size: 0.875rem;
    line-height: 1.5;
    color: ${getPurpurColor('gray700')};
`;

export const HelpTooltip = styled(Tooltip)`
    flex-shrink: 0;
    max-width: 350px;
    text-decoration: none;
`;
